const state = {
  mini: false,
  showAttackList: true,
  chatList: true,
  globalDrawer: false,
  isGlobal: false,
  menuKey: 0,
  menuItems: [
    {
      title: "Dashboard",
      permissionCode: "dashboard",
      icon: "mdi-view-dashboard",
      url: "/",
    },
    {
      title: "Users",
      permissionCode: "user",
      icon: "mdi-account-multiple",
      url: "/users",
    },
    {
      title: "HR",
      permissionCode: "hr",
      groupName: "hr",
      icon: "mdi-account-supervisor",
      isTicket: true,
      subItems: [
        {
          title: "Personal Information",
          permissionCode: "personal_information",
          icon: "mdi-account",
          url: "/hr/personal-information/",
          dynamic: true,
        },
        {
          title: "Employees",
          permissionCode: "employees",
          icon: "mdi-account-supervisor",
          url: "/hr/employees",
        },
        {
          title: "Leaves",
          permissionCode: "employee_leave_request",
          icon: "mdi-road-variant",
          url: "/hr/leaves",
        },
        {
          title: "Bulk Leaves",
          permissionCode: "bulk_leaves",
          icon: "mdi-account-multiple-check",
          url: "/hr/bulkleaves",
        },
        {
          title: "Leave List",
          permissionCode: "employee_leave_list",
          icon: "mdi-clipboard-list",
          url: "/hr/leavelist",
        },
        {
          title: "Holidays",
          permissionCode: "holidays",
          icon: "mdi-calendar",
          url: "/hr/holidays",
        },
        {
          title: "Manager Reports",
          permissionCode: "employee_with_managers",
          icon: "mdi-file-chart",
          url: "/hr/manager-reports",
        },
        {
          title: "Yearly Leave Reports",
          permissionCode: "yearly_leave_reports",
          icon: "mdi-chart-bubble",
          url: "/hr/yearlyleavereports",
        },
        {
          title: "Office Usage Report",
          permissionCode: "office_usage_report",
          icon: "mdi-table-large",
          url: "/hr/officeusagereport",
        },
      ],
    },
    {
      title: "Customers",
      permissionCode: "customer",
      icon: "mdi-account-group",
      url: "/customers",
    },
    {
      title: "Stakeholders",
      permissionCode: "provider",
      icon: "mdi-account-network",
      url: "/stakeholders",
    },
    {
      title: "Project Management",
      permissionCode: "projects",
      groupName: "project",
      icon: "mdi-file-table-box-multiple",
      subItems: [
        {
          title: "Projects",
          permissionCode: "projects",
          icon: "mdi-file-table-box-multiple",
          url: "/project/projects",
        },
        {
          title: "Data Destruction Dashboard",
          permissionCode: "project_data_destruction_dashboard",
          icon: "mdi-view-dashboard-outline",
          url: "/project/data-destruction-dashboard/",
        },
      ],
    },
    {
      title: "Products",
      permissionCode: "products_product_history",
      icon: "mdi-package-variant-closed",
      url: "/products",
      isTicket: true,
    },
    {
      title: "Ticket Management",
      groupName: "ticket",
      permissionCode: "ticket_management",
      icon: "mdi-ticket",
      subItems: [
        {
          title: "Tickets",
          permissionCode: "tickets",
          icon: "mdi-tag-multiple",
          url: "/ticket/tickets",
        },
        {
          title: "Onboarding",
          permissionCode: "onboarding",
          icon: "mdi-account-plus-outline",
          url: "/ticket/onboarding",
        },
        {
          title: "Dashboard",
          subheader: true,
          subHeaderGroup: "ticket-dashboard",
        },
        {
          title: "Dashboard - 1",
          permissionCode: "ticket_dashboard",
          icon: "mdi-ticket-account",
          url: "/ticket/dashboard",
          subHeaderGroup: "ticket-dashboard",
        },
        {
          title: "Dashboard - 2",
          permissionCode: "ticket_dashboard_2",
          icon: "mdi-ticket-confirmation",
          url: "/ticket/dashboard-2",
          subHeaderGroup: "ticket-dashboard",
        },
        {
          title: "Reports",
          subheader: true,
          subHeaderGroup: "ticket-reports",
        },
        {
          title: "Ticket",
          permissionCode: "ticket_management_report_ticket",
          icon: "mdi-chart-pie",
          url: "/ticket/ticket-report",
          subHeaderGroup: "ticket-reports",
        },
        {
          title: "Ticket Type",
          permissionCode: "ticket_management_report_ticket_type",
          icon: "mdi-chart-bar",
          url: "/ticket/ticket-type-report",
          subHeaderGroup: "ticket-reports",
        },
        {
          title: "Task",
          permissionCode: "ticket_management_report_task",
          icon: "mdi-chart-ppf",
          url: "/ticket/task",
          subHeaderGroup: "ticket-reports",
        },
        {
          title: "Company/Technology",
          permissionCode: "ticket_management_report_companytechnology",
          icon: "mdi-poll",
          url: "/ticket/company-technology",
          subHeaderGroup: "ticket-reports",
        },
      ],
    },
    {
      title: "Capacity",
      groupName: "capacity",
      permissionCode: "capacity",
      icon: "mdi-account-clock-outline",
      subItems: [
        {
          title: "Calendar",
          permissionCode: "capacity_calendar",
          icon: "mdi-calendar-month",
          url: "/capacity/calendar",
        },
        {
          title: "Reports",
          icon: "mdi-view-list",
          permissionCode: "capacity_capacity_reports",
          url: "/capacity/reports",
        },
        {
          title: "Waiting Approval",
          icon: "mdi-check-decagram-outline",
          permissionCode: "waiting_approval",
          url: "/capacity/waiting_approval",
        },
        {
          title: "Teams Management",
          permissionCode: "team_management",
          icon: "mdi-account-group-outline",
          url: "/capacity/team-management",
        },
        {
          title: "Yearly Report Person",
          icon: "mdi-chart-bell-curve-cumulative",
          permissionCode: "capacity_yearly_report_person",
          url: "/capacity/yearly-report-person",
        },
        {
          title: "Activity Tracking",
          permissionCode: "activity_tracking",
          icon: "mdi-file-chart",
          url: "/capacity/activity-tracking",
        },
      ],
    },
    {
      title: "Budget Management",
      groupName: "budget",
      permissionCode: "budget_management",
      icon: "mdi-cash",
      isTicket: true,
      subItems: [
        {
          title: "Plans",
          subheader: true,
          subHeaderGroup: "budget-plans",
        },
        {
          title: "Planned Personnel",
          permissionCode: "planned_personnels",
          icon: "mdi-account-sync",
          url: "/budget/planned-personnel",
          subHeaderGroup: "budget-plans",
        },
        {
          title: "Planned Budgets",
          permissionCode: "planned_budgets",
          icon: "mdi-cash-multiple",
          url: "/budget/planned-budgets",
          subHeaderGroup: "budget-plans",
        },
        {
          title: "Actual Budgets",
          permissionCode: "actual_budget",
          icon: "mdi-cash-fast",
          url: "/budget/actual-budgets",
          subHeaderGroup: "budget-plans",
        },

        {
          title: "Reports",
          subheader: true,
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Summary Budget Report",
          permissionCode: "summary_budget_report",
          icon: "mdi-cash-multiple",
          url: "/budget/summary-budget-report",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Detailed Budget Report",
          permissionCode: "detailed_budget_report",
          icon: "mdi-cash",
          url: "/budget_management/detailed-budget-report",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Receivable Reports",
          permissionCode: "receivable_report",
          icon: "mdi-abacus",
          url: "/budget/receivable-reports",
          subHeaderGroup: "budget-reports",
        },

        {
          title: "Bank Balance Reports",
          permissionCode: "bank_balance_report",
          icon: "mdi-bank",
          url: "/budget/bank-balances",
          subHeaderGroup: "budget-reports",
        },

        {
          title: "Receipts&Payments Reports",
          permissionCode: "collections_and_payments",
          icon: "mdi-cash-sync",
          url: "/budget/receipts-and-payments",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Plan Status Reports",
          permissionCode: "plan_status_reports",
          icon: "mdi-list-status",
          url: "/budget/plan-status-reports",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "All Budget Reports",
          permissionCode: "all_budget_reports",
          icon: "mdi-poll",
          url: "/budget/all-budget-reports",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Monthly Budget Reports",
          permissionCode: "all_monthly_reports",
          icon: "mdi-calendar-range-outline",
          url: "/budget/budget-reports-by-month",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Personnel Reports",
          permissionCode: "personnel_reports",
          icon: "mdi-account-search",
          url: "/budget/personnel-reports",
          subHeaderGroup: "budget-reports",
        },
        {
          title: "Settings",
          subheader: true,
          subHeaderGroup: "budget-settings",
        },
        {
          title: "Expense Parameters",
          permissionCode: "expense_parameters",
          icon: "mdi-cash-edit",
          url: "/budget/expense-parameters",
          subHeaderGroup: "budget-settings",
        },
        {
          title: "Exchange Rates",
          permissionCode: "exchange_rates",
          icon: "mdi-currency-usd",
          url: "/budget/exchange-rates",
          subHeaderGroup: "budget-settings",
        },
        {
          title: "Virtual Departments",
          permissionCode: "virtual_department",
          icon: "mdi-source-repository-multiple",
          url: "/budget/virtual-departments",
          subHeaderGroup: "budget-settings",
        },
        {
          title: "Barikat Divisions",
          permissionCode: "barikat_division",
          icon: "mdi-home-group",
          url: "/budget/barikat-divisions",
          subHeaderGroup: "budget-settings",
        },
        {
          title: "Fuel Limit for Title",
          permissionCode: "fuel_limits_for_title",
          icon: "mdi-account-tie",
          url: "/budget/fuel-limit-for-title",
          subHeaderGroup: "budget-settings",
        },
      ],
    },
    {
      title: "Settings",
      groupName: "settings",
      permissionCode: "settings",
      icon: "mdi-cogs",
      isTicket: true,
      subItems: [
        {
          title: "Roles & Permissions",
          permissionCode: "roles_permissions",
          icon: "mdi-security",
          url: "/settings/roles-permissions",
        },
        {
          title: "Custom Permissions",
          permissionCode: "custom_permissions",
          icon: "mdi-security",
          url: "/settings/custom-permissions",
        },
        {
          title: "Departments",
          permissionCode: "departments",
          icon: "mdi-source-repository-multiple",
          url: "/settings/departments",
        },
        {
          title: "SKU",
          permissionCode: "sku",
          icon: "mdi-clipboard-text-multiple",
          url: "/settings/sku",
        },
        {
          title: "Parameters",
          permissionCode: "parameters",
          icon: "mdi-folder-table",
          url: "/settings/parameters",
        },
        {
          title: "Logs",
          permissionCode: "logs",
          icon: "mdi-history",
          url: "/settings/logs",
        },
        {
          title: "Sync Logs",
          permissionCode: "logs",
          icon: "mdi-file-alert-outline",
          url: "/settings/sync-logs",
        },
        {
          title: "System Jobs",
          permissionCode: "roles_permissions",
          icon: "mdi-wrench",
          url: "/settings/system-jobs",
        },
        {
          title: "Issue Types",
          permissionCode: "issue_types",
          icon: "mdi-list-status",
          url: "/settings/issues-types",
        },
        {
          title: "Issue States",
          permissionCode: "issue_states",
          icon: "mdi-state-machine",
          url: "/settings/issues-states",
        },
        {
          title: "Application Settings",
          permissionCode: "application_settings",
          icon: "mdi-cog-outline",
          url: "/settings/application-settings",
        },
      ],
    },
    {
      title: "Reports",
      groupName: "reports",
      permissionCode: "reports",
      icon: "mdi-view-list",
      subItems: [
        {
          title: "Service",
          permissionCode: "service",
          icon: "mdi-chart-box",
          url: "/reports/service",
        },
        {
          title: "Overexertion Report",
          permissionCode: "overexertion_report",
          icon: "mdi-finance",
          url: "/reports/overexertion-report",
        },
      ],
    },
    {
      title: "Data Desctruction",
      permissionCode: "data_destruction",
      icon: "mdi-delete-forever",
      url: "/data-destruction",
    },
    {
      title: "Opportunity Projects",
      permissionCode: "opportunity_project",
      icon: "mdi-lightbulb-on",
      url: "/opportunity-projects",
    },
    {
      title: "Targets",
      permissionCode: "target",
      icon: "mdi-bullseye-arrow",
      url: "/targets",
    },
  ],
};
const getters = {
  getMini(state) {
    return state.mini;
  },
  getMenuItems(state) {
    return state.menuItems;
  },
  getChatList(state) {
    return state.chatList;
  },
  getGlobalDrawer(state) {
    return state.globalDrawer;
  },
  getIsGlobal(state) {
    return state.isGlobal;
  },
};
const mutations = {
  SET_MINI(state) {
    state.mini = !state.mini;
  },
  SET_CHAT_LIST(state, val) {
    state.chatList = val;
  },
  SET_GLOBAL_DRAWER(state, val) {
    state.globalDrawer = val;
  },
  SET_SHOW_ATTACK_LIST(state) {
    state.showAttackList = !state.showAttackList;
  },
  SET_IS_GLOBAL(state, val) {
    state.isGlobal = val;
  },
  SET_MENU_KEY(state) {
    state.menuKey++;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
